import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class StudiesLevel  {
    _originalTypeClassName = "zERP.BO.StudiesLevel";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
StudiesLevel.translate = translateService;
}
this.Levels = [];
this.Id = null;
this.Name = null;
this.Description = null;
this.Code = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Name:any;
Description:any;
Code:any;
Levels:any;
static setLevels = ($this, items) => {
                if (items == null) items = [];
                if ($this.Levels == null) $this.Levels = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Levels.length > 0) {
                    Domain.StudiesLevel.removeLevels($this, $this.Levels[0]);
                }

                Domain.StudiesLevel.addManyLevels($this, copyItems);
            }
static addManyLevels = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.StudiesLevel.addLevels($this, items[i]);
                }
            }
static addLevels = ($this, item) => {
                if ($this.Levels == null) $this.Levels = [];
                if (item == null || $this.Levels.indexOf(item) > -1) return;
                $this.Levels.push(item);
}
static addRangeLevels = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.StudiesLevel.addLevels($this, item));
            }
static removeLevels = ($this, item) => {
                if ($this == null || $this.Levels == null || $this.Levels.indexOf(item) === -1) return;
                var _index = $this.Levels.indexOf(item);
                $this.Levels.splice(_index, 1);
}
static clearLevels = ($this) => { $this.Levels = null; }

static GetClassName(): any{return "StudiesLevel";
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}